import React from 'react';
import FileDropzone from './FileDropzone';

const AnnexEditor = ({ title, setTitle, files, setFiles, titleLabel = 'Annex title', accept = 'image/*,.pdf', options = null }) => {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr' }}>
      <div className="info-label-cell">{titleLabel}</div>
      <div className="info-value-cell">
        {Array.isArray(options) && options.length > 0 ? (
          <select
            className="cell-input"
            value={title || ''}
            onChange={(e) => setTitle(e.target.value)}
          >
            <option value="" disabled>Select {titleLabel.toLowerCase()}</option>
            {options.map((opt) => {
              const value = typeof opt === 'string' ? opt : (opt.title || '');
              return (
                <option key={typeof opt === 'string' ? opt : (opt.id || value)} value={value}>
                  {value}
                </option>
              );
            })}
          </select>
        ) : (
          <input
            type="text"
            className="cell-input"
            placeholder={`Enter ${titleLabel.toLowerCase()}`}
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        )}
      </div>

      <div className="info-label-cell">Files</div>
      <div className="info-value-cell">
        <FileDropzone
          files={files}
          setFiles={setFiles}
          accept={accept}
        />
      </div>
    </div>
  );
};

export default AnnexEditor;
